import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SHARED_FEATURE_KEY, SharedState} from "./shared.reducer";

export const getSharedState = createFeatureSelector<SharedState>(SHARED_FEATURE_KEY);

export const getDocumentScanningStatus = createSelector(
  getSharedState,
  (state) => state.documentScanningStatus
);

export const getDocumentScanningError = createSelector(
  getSharedState,
  (state) => state.errors
);

export const getQrCodeValue = createSelector(
  getSharedState,
  (state) => state.shortUrl
);

export const getSkipDocumentScanning = createSelector(
  getSharedState,
  (state) => state.skipDocumentScanning
);

export const getAutoFill = createSelector(
  getSharedState,
  (state) => state.autoFill
);
